import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { IMultiAccount } from '../../../../models/UserInfo';
import { ReactComponent as DragAndDropIcon } from '../../../../assets/images/DragAndDropIcon.svg';

interface IPrioritiesTable {
  item: IMultiAccount;
  isLoading: boolean;
  isStatic?: boolean;
}

export const PrioritiesTable: FC<IPrioritiesTable> = ({ item, isLoading, isStatic }) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery('(hover: none)');
  const sortable = !isStatic ? useSortable({ id: item.id }) : null;

  const style: React.CSSProperties = {
    transform: sortable ? CSS.Transform.toString(sortable.transform) : undefined,
    transition: sortable ? sortable.transition : undefined,
    opacity: sortable?.isDragging || isLoading ? 0.6 : 1,
    cursor: isStatic ? 'default' : `${sortable?.isDragging ? 'grabbing' : 'pointer'}`,
    touchAction: isStatic || isMobile ? 'auto' : 'none',
    zIndex: isStatic || !sortable?.isDragging ? 'auto' : '2',
    WebkitUserSelect: 'none',
    userSelect: 'none',
  };

  return (
    <div
      ref={sortable ? sortable.setNodeRef : undefined}
      style={style}
      {...(sortable ? sortable.attributes : {})}
      {...(sortable && !isMobile ? sortable.listeners : {})}
      className={`multi-account__admin__table-entry ${item.Role === 'admin' ? 'admin-entry' : ''}`}
    >
      <div className="multi-account__admin__table-meta">
        <div className="multi-account__admin__table-profile">
          <div
            className="multi-account__admin__table-thumbnail"
            style={{
              touchAction: isStatic || !isMobile ? 'auto' : 'none',
              WebkitUserSelect: 'none',
              userSelect: 'none',
            }}
            {...(sortable && isMobile ? sortable.listeners : {})}
          >
            <DragAndDropIcon />
          </div>
          <div className="multi-account__admin__table-agreement">
            {item.Alias || (
              <>
                {t('multiAccount.account')} <span>{item.UserID}</span>
              </>
            )}
            <p className={`multi-account__admin__table-agreement-${item.UseAutoPay ? 'enabled' : 'disabled'}`}>
              <span>{t('multiAccount.autopay')}</span>{' '}
              {item.UseAutoPay ? t('multiAccount.autopayEnabled') : t('multiAccount.autopayDisabled')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
